import React from "react"

import FieldProjects from "../projects"
import SelectParentsNew from "../../../../../gd-ui/select-parent-new/select-parents-new"
import {SelectParent_RenderType} from "../../../../../gd-ui/select-parent-new/@const"

type Props = {
    field       : FieldProjects
    model       : any
    onChange?   : onChangeCallback
    className?  : string,
    options?    : any
};

export default function FieldProjects_InlineEditable(props: Props) {

    const onChange = (projectIds: ID[]) => {
        props.onChange?.(projectIds)
    }

    const value = props.model[props.field.fieldId]
    const {field} = props

    const unselectLabel = field.noValueOption ? field.noValueOptionLabel || undefined : undefined

    return <SelectParentsNew className              = {props.className}
                             renderType             = {SelectParent_RenderType.INLINE_EDITABLE}
                             placeholder            = {field.placeholder}
                             unselectLabel          = {unselectLabel}
                             displayWorkspaceRoot   = {field.displayWorkspaceRoot}
                             parentsFor             = {field.parentsFor}
                             projectIds             = {value}
                             onChange               = {onChange}/>

    /*return <SelectParent className      = {props.className}
                       renderValue      = "inline-editable"
                       parentsFor       = {field.parentsFor}
                       viewMode         = {field.viewMode}
                       multiselect      = {true}
                       placeholder      = {field.placeholder}
                       unselectLabel    = {unselectLabel}
                       companies        = {[gd.companyId]}
                       values           = {value ? {projects:value} : null}
                       showProjectIcon  = {true}
                       showIcon         = {true}
                       searchable       = {true}
                       onChange         = {onChange}/>*/
}